/** Shared look of the header search fields (element search on map tabs; the zone search shares the icon). */
export const searchInputClass =
  'px-2 py-[5px] bg-white dark:bg-primary-700 border border-gray-300 dark:border-primary-500 text-gray-900 dark:text-primary-100 placeholder:text-gray-500 dark:placeholder:text-primary-400 rounded focus:outline-hidden focus:ring-1 focus:ring-accent-primary text-xs';

export function SearchIcon({ className = 'w-3.5 h-3.5' }: { className?: string }) {
  return (
    <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
    </svg>
  );
}
